import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgSnapchatIcon(props) {
  return jsx("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M15.964 12.27c-.163.38-.851.66-2.105.855-.065.087-.118.459-.203.748-.051.174-.176.277-.38.277h-.009c-.293 0-.6-.135-1.214-.135-.829 0-1.114.189-1.758.643-.682.483-1.336.9-2.313.857-.989.073-1.813-.529-2.277-.857-.648-.457-.932-.643-1.758-.643-.59 0-.96.148-1.214.148-.252 0-.35-.154-.388-.283-.085-.287-.138-.664-.204-.754-.646-.1-2.103-.354-2.14-1.005a.332.332 0 0 1 .277-.346c2.174-.357 3.154-2.59 3.194-2.685l.008-.016c.116-.236.142-.433.077-.586-.158-.372-.84-.505-1.127-.619-.74-.292-.844-.629-.8-.86.076-.4.679-.647 1.031-.482.279.13.526.197.736.197a.638.638 0 0 0 .311-.068c-.064-1.123-.222-2.728.178-3.624C4.94.666 7.178.482 7.838.482l.316-.003c1.63 0 3.196.837 3.96 2.551.4.896.242 2.494.178 3.626.05.027.136.06.269.066.2-.008.432-.074.69-.195a.846.846 0 0 1 .64.002c.297.106.483.32.488.559.005.304-.267.567-.809.781a3.822 3.822 0 0 1-.232.08c-.306.096-.769.243-.894.539-.066.153-.04.35.076.586a.2.2 0 0 1 .008.016c.04.095 1.02 2.327 3.194 2.685.201.033.35.246.242.496Z",
    fill: "currentColor"
  }));
}

export { SvgSnapchatIcon as default };
